import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import arrowDownIcon from '../../assets/icons/LayoutIcons/arrow-down.svg';
import Sidebar from './Sidebar';
import getInitials from '../../lib/getInitials';
import LogoutCard from '../global/LogoutCard';
import { useAppSelector } from '../../app/hooks';

const MobileRightNavigation = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const ref: any = useRef(null);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const details = useAppSelector((state) => state.auth.loggedInUserDetails);
  const fullName = details?.firstName + ' ' + details?.lastName;
  const userEmail = details?.email;

  const [showLogout, setShowLogout] = useState(false);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const setLogoutStatefalse = (e: any) => {
    if (ref.current && showLogout && !ref.current.contains(e.target)) {
      setShowLogout(false);
    }
  };
  document.addEventListener('click', setLogoutStatefalse);

  return (
    <nav className='translate-x-0 h-screen  md:translate-x-[100%] transition-all fixed bg-offDark top-0 left-0 w-[235px] z-[100000]'>
      <div className='flex h-[180px]  flex-col items-center border-b-2 border-[#7683968f] justify-center space-y-3'>
        <div className='w-[71px] h-[71px] bg-green rounded-full flex items-center justify-center text-[34px] text-white font-poppins '>
          {getInitials(fullName)}
        </div>
        <div className='flex items-center space-x-3'>
          <h3 className='font-poppins font-medium text-green text-[21px]'>{details?.firstName}</h3>
          <div className='relative'>
            <div className='cursor-pointer'>
              <img
                src={arrowDownIcon}
                ref={ref}
                className='w-[20px]'
                alt='arrowDownIcon'
                onClick={() => setShowLogout((prev) => !prev)}
              />
            </div>

            {showLogout && <LogoutCard />}
          </div>
        </div>

        <div className='cursor-pointer'>
          <p className='text-[#768396] text-[12px]'>{userEmail}</p>
        </div>
      </div>
      <Sidebar />
    </nav>
  );
};

export default MobileRightNavigation;
